<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width" [class.toolbar-empty]="!form">
        <!-- Bug 6961: below md show the page title only while no record is open, so the header stays compact once one is -->
        <div class="col-sm-12 col-title d-print-none d-none d-md-flex align-items-center" [ngClass]="{ 'd-flex': !form }">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div
          class="col-12 col-sm-4 col-md-3 d-flex align-items-start flex-column justify-content-center"
        >
          <h1
            [ngClass]="form?.formVersion?.status?.color"
            id="serialNumber"
            [matTooltip]="form?.wfTable?.name ?? ''"
          >
            {{ form?.sequenceNumber?.number?.trim() }}
          </h1>
          <span
            *ngIf="form"
            class="status"
            [ngClass]="form.formVersion.status.color"
          >
            {{ form.formVersion.status.name }}
          </span>
        </div>
        <!-- Bug 6961: sit beside the serial number from sm up, and share one row with Created Date on phones -->
        <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="form"
            class="no-subscript"
          >
            <mat-label>Initiated by</mat-label>
            <input
              aria-label="operator"
              matInput
              type="text"
              name="operator_form"
              [(ngModel)]="form.formVersion.operatorInitiatingForm.name"
              disabled
            />
          </mat-form-field>
        </div>
        <div class="col-6 col-sm-4 col-md-2 type-header d-flex align-items-center">
          <mat-form-field
            appearance="outline"
            *ngIf="form"
            class="no-subscript"
          >
            <mat-label>Created Date</mat-label>
            <input
              matInput
              class="dateInput"
              name="dateNow"
              placeholder="Date"
              disabled
              datetime="MM-dd-yyyy"
              [value]="formatDate(form.date)"
            />
          </mat-form-field>
        </div>
        <div
          class="col-12 col-md-2 d-flex flex-column justify-content-center align-items-end"
        >
          <div
            class="small"
            *ngIf="
              form?.formVersion?.status?.amendment &&
              form?.formVersion?.previousVersionID
            "
          >
            <mat-slide-toggle
              [checked]="showAmendment"
              class="float-right d-print-none"
              name="amendment"
              (change)="changeAmendmentToggle($event)"
              >Show Pending Amendment</mat-slide-toggle
            >
          </div>
          <div class="d-flex small d-print-none" *ngIf="form?.editingBy">
            Modifying by:&nbsp;<b class="yellow">{{ form?.editingBy?.name }}</b>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item class="">
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div [ngClass]="{ invisible: !isExpanded && !isShowing }">
            <eb-side
              #side
              [formsFilter]="filter"
              (rowSelected)="rowSelected($event)"
            ></eb-side>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.EBNewForm) &&
            form?.formVersion?.statusID != formStatusEnum.New
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="edit(true)"
          class="parent"
          *ngIf="
            hasPrivilege(privilegeEnum.EBNewForm) &&
            form?.formVersion?.statusID == formStatusEnum.Draft &&
            !form?.editingBy
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Form</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="editAmendment()"
          class="parent"
          *ngIf="
            form &&
            hasPrivilege(privilegeEnum.EBEditAmendment) &&
            !form.editingBy &&
            form.formVersion.statusID == formStatusEnum.AmendmentDrafting
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Amendment</span
          >
          <mat-icon matListItemIcon class="yellow">edit</mat-icon>
        </mat-list-item>

        <olog-button
          *ngIf="form"
          [disabled]="form.formVersion.statusID != formStatusEnum.Draft"
          [documentTypeID]="formTypeEnum.EBF"
          [documentID]="form.id"
          [isExpandedOrShowing]="isExpanded || isShowing"
        ></olog-button>

        <mat-list-item
          (click)="duplicate()"
          class="parent"
          *ngIf="
            form &&
            hasPrivilege(privilegeEnum.EBNewForm) &&
            form?.formVersion?.statusID !== formStatusEnum.New
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Copy Form</span
          >
          <mat-icon matListItemIcon class="blue">content_copy</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="requestAmendment()"
          class="parent"
          *ngIf="showAmendmentButton()"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create Amendment</span
          >
          <mat-icon matListItemIcon class="red">healing</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="edit(false)"
          class="parent"
          *ngIf="
            form?.editingBy &&
            (hasRoles([roleEnum.SA, roleEnum.ADM]) ||
              form?.editingBy?.id == getCurrentUser()?.id)
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Release Form</span
          >
          <mat-icon matListItemIcon class="red">lock_open</mat-icon>
        </mat-list-item>
        <form-history-button
          #showHistory
          [isExpanded]="isExpanded"
          [isShowing]="isShowing"
          [hidden]="!form"
        ></form-history-button>
        <!-- <mat-list-item
          *ngIf="isSA()"
          (click)="settings()"
          class="parent line-top"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Settings</span
          >
          <mat-icon matListItemIcon class="gray">settings</mat-icon>
        </mat-list-item> -->
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div
          class="sidenav-content"
          [ngClass]="{
            amendment: showAmendment
          }"
        >
          <eb-main
            *ngIf="!showHistory.value"
            [form]="form"
            [showAmendment]="showAmendment"
            (formCreated)="formCreated($event)"
            (formCancelled)="formCancelled($event)"
          ></eb-main>
          <form-history
            [form]="form"
            class="mt-2"
            *ngIf="showHistory.value"
          ></form-history>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
